import { render, staticRenderFns } from "./footer-full.vue?vue&type=template&id=db8cdd8a&"
import script from "./footer-full.vue?vue&type=script&lang=ts&"
export * from "./footer-full.vue?vue&type=script&lang=ts&"
import style0 from "./footer-full.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports